import React, { useState } from "react";
import './Login.css'
import apiClient from "./ApiClient";

function Login({ setAuthToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();  // Prevent page refresh
  
    try {
      // Axios POST request using apiClient
      const response = await apiClient.post("/token/", {
        username, 
        password
      });
  
      const { access, refresh } = response.data;

      if(!!access && !!refresh) {
  
        // Store tokens in state and localStorage
        setAuthToken(access);
        localStorage.setItem("refresh_token", refresh);
        localStorage.setItem("access_token", access);

        console.log(JSON.parse(atob(access.split('.')[1])));
        console.log(JSON.parse(atob(refresh.split('.')[1])));

    
        console.debug("Stored access token:", access);
        console.debug("Stored refresh token:", refresh);
        
      }
  
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed!");
    }
  };

  return (
    <div className="login-container">
      <h2>Log in to BetterBaduk</h2>
      <form className="login-form" onSubmit={handleLogin}>
        <div className="input-group">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button blue">Log in</button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
}

export default Login;